import * as constants from './constants';
import { site_survey_questions } from '../components/site_survey/site_survey_form_elevator';

export const machineryTypeMap = {
    [constants.GEARED]: 'machineryGeared',
    [constants.GEARLESS]: 'machineryGearless',
    [constants.HYDRAULIC]: 'machineryHydraulic'
};

export const mapRepairPackagesToFormState = (plannerLeads, formattedFormData) => {
    const repairPackages = [];
    const chosenMachineType = machineryTypeMap[formattedFormData.machineryType] || null;

    Object.keys(plannerLeads).forEach(component => {
        const isMachineryComponent = component.includes('machinery') && !component.includes('machineryArea');

        if (!chosenMachineType || (!isMachineryComponent || component.includes(chosenMachineType))) {
            const laborHoursValue = plannerLeads[component].labourHours;
            const repairPackage = {
                component: component,
                additionalComments: plannerLeads[component].additionalComments,
                materialLabourHours: laborHoursValue ? laborHoursValue : 0,
                materials: [],
                psrPackages: []
            };

            plannerLeads[component].materials.forEach(material => {
                const quantity = parseInt(material.quantity, 10);
                const repairMaterial = {
                    plateMaterial: material.name,
                    materialQuantity: quantity ? quantity : 0
                };

                repairPackage.materials.push(repairMaterial);
            });

            plannerLeads[component].psrPackages.forEach(psr => {
                const quantity = parseInt(psr.quantity, 10);
                const psrPackage = {
                    psrPackage: psr.name,
                    psrPackageQuantity: quantity ? quantity : 0
                };

                repairPackage.psrPackages.push(psrPackage);
            });
            
            repairPackages.push(repairPackage);
        }
    });

    return repairPackages;
};

const formatFormData = (formData) => {
    const formattedData = {};

    for (var i in formData) {
        try {
            if (formData[i].value != undefined) {
                formattedData[i] = formData[i].value;
            }
        } catch (ignored) { }
    }

    return formattedData;
}

export const mapDetailsForSurveySubmission = (formData, equipment, plannerLeads, serviceOrder) => {  
    const formattedFormData = formatFormData(formData)
    // Create the payload hierarchy as its displayed in the UI
    const surveyResponsePayload = createPayloadHierarchy(site_survey_questions, formattedFormData);
    
    const siteSurveySubmissionRequest = {
        surveyResponses: surveyResponsePayload
    };
    siteSurveySubmissionRequest[constants.KEN] = equipment.EquipmentNumberKENformatted;
    siteSurveySubmissionRequest[constants.IS_KONE] = equipment.isKone;
    siteSurveySubmissionRequest[constants.COUNTRY_CODE] = equipment.EquipmentCountryCode;
    siteSurveySubmissionRequest[constants.SITE_LOCATION] = equipment.EquipmentAddressName1;
    siteSurveySubmissionRequest[constants.NO_OF_FLOORS] = 0;
    siteSurveySubmissionRequest[constants.SERVICE_ORDER] = serviceOrder;
    siteSurveySubmissionRequest[constants.CREATED_BY] = 'Site Survey Application';
    siteSurveySubmissionRequest[constants.REPAIR_PACKAGES] = mapRepairPackagesToFormState(plannerLeads, formattedFormData);

    return siteSurveySubmissionRequest;
};

function createPayloadHierarchy(questions, formattedFormData) {
    const payload = {};
    const chosenMachineType = machineryTypeMap[formattedFormData.machineryType] || null;

    questions.forEach(step => {
      const stepName = step.step;
      const isMachineryStep = Object.values(machineryTypeMap).includes(stepName);

      if (!isMachineryStep || (isMachineryStep && chosenMachineType === stepName)) {
        payload[stepName] = {};

        step.fields.forEach(field => {
            if (field.type == 'text-area' || field.type == 'date') {
                payload[stepName][field.id] = formattedFormData[field.id] || '';
            } else if (field.id === 'pitOSGTensionWeight') {
                payload[stepName][field.id] = formattedFormData[field.id] || 0;
            } else if (field.type !== 'conditionalComponent' && field.type !== 'image') {
                payload[stepName][field.id] = formattedFormData[field.id] || constants.NO_RESPONSE;
            }
        });
      }
    });
  
    return payload;
}

export const filterImagesByMachineryType = (formData) => {
    let data = formData

    if (data['machineryType']) {
        const machinery = machineryTypeMap[data['machineryType'].value];

        Object.keys(data).forEach((component) => {
            if (component.startsWith('machinery') && !component.startsWith('machineryArea') && !component.startsWith(machinery)) {
                delete formData[component];
            }
        });
    }

    return formData;
}

export const mapComponentNameToImage = (image) => {
    const component = site_survey_questions.find(step => image.key.startsWith(step.step));
    let componentName = image.key;

    if (component.step == 'machinery') {
        switch (image.key) {
            case 'machineryGearedPicture':
                componentName = 'machineryGeared';
                break;
            case 'machineryGearlessPicture':
                componentName = 'machineryGearless';
                break;
            case 'machineryHydraulicPicture':
                componentName = 'machineryHydraulic';
                break;
        }
    }

    return componentName;
};